import { List, ListItem, Typography, Box } from '@mui/material';
import type { BetBuilderSelection } from '../../@types/api';
import { StyleObj } from '../../@types';

const styles: StyleObj = {
  root: {
    width: '100%',
    py: 1,
    px: 2,
    backgroundColor: 'background.lighter',
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
    py: 0.5,
    px: 0,
    position: 'relative',
    '&:not(:last-child)::before': {
      content: '""',
      position: 'absolute',
      left: '7px',
      top: '20px',
      bottom: -10,
      width: '1px',
      backgroundColor: 'primary.light',
    },
  },
  dot: {
    width: '16px',
    height: '16px',
    minWidth: '16px',
    borderRadius: '50%',
    border: '2px solid',
    borderColor: 'primary.main',
    backgroundColor: 'background.paper',
    mt: '2px',
    zIndex: 1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
  },
  outcomeName: {
    fontWeight: 600,
  },
  marketName: {
    color: 'text.secondary',
    fontSize: '0.75rem',
  },
  list: {
    p: 0,
  },
};

type Props = {
  selections: BetBuilderSelection[];
};

const BetBuilderSelectionsList = ({ selections }: Props) => {
  if (!selections || selections.length === 0) return null;

  return (
    <Box sx={styles.root}>
      <List sx={styles.list}>
        {selections.map((selection) => {
          const specialValue = selection.outcome.properties?.specialValue;

          return (
            <ListItem key={selection.id} sx={styles.listItem}>
              <Box sx={styles.dot} />
              <Box sx={styles.content}>
                <Typography variant='body3' sx={styles.outcomeName}>
                  {selection.outcome.shortName ?? selection.outcome.name}
                  {specialValue && ` (${specialValue})`}
                </Typography>
                <Typography variant='body3' sx={styles.marketName}>
                  {selection.market.shortName ?? selection.market.name}
                </Typography>
              </Box>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default BetBuilderSelectionsList;
